import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams, useNavigate } from 'react-router-dom'

import type { TrackId } from 'types/track'

import { getOrFetchTrack } from '@disco/state-management/actions/PlaylistTrackActions'

import { getTrack } from '@disco/state-management/selectors/tracks'

import DocumentHeadTags from 'components/document-head-tags'
import TrackTagModal from 'components/modals/track/track-tag'
import Heading from 'components/ui/heading'
import ModalWindow from 'components/ui/modal-window'
import Spinner from 'components/ui/spinner'

const TrackTag = (): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ trackId: string; sourceLibraryId?: string }>()
  const trackId = params.trackId as unknown as TrackId
  const sourceLibraryId = params.sourceLibraryId
    ? parseInt(params.sourceLibraryId)
    : undefined
  const track = useSelector(state => getTrack(state, { id: trackId }))

  const onClose = () => navigate('/')

  useEffect(() => {
    if (!track) {
      // @ts-ignore
      dispatch(getOrFetchTrack(trackId, sourceLibraryId))
    }
  }, [track, trackId, sourceLibraryId])

  if (!track) {
    return (
      <>
        <DocumentHeadTags title="Track tags | DISCO" />
        <ModalWindow
          header={<Heading size="700">Track Tags</Heading>}
          width="medium"
          onClose={onClose}
          isOpen
        >
          <Spinner />
        </ModalWindow>
      </>
    )
  }

  const searchParams = new URLSearchParams(location.search)
  const type = searchParams.get('type')

  return (
    <>
      <DocumentHeadTags title="Track Tags | DISCO" />
      <TrackTagModal type={type} track={track} onClose={onClose} />
    </>
  )
}

export default TrackTag
